import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import isExternalHref from "@casino/shared/utils/router/isExternalHref";
import { resolveHref } from "next/dist/client/resolve-href";
import type { Router } from "next/router";
import type { LinkProps } from "..";

const usePatchHrefLocale = () => {
  const { language, siteConfig } = useAppContext();
  const router = useRouter();
  const patchHrefLocale = (href: LinkProps["href"]) => {
    if (isExternalHref(href.toString())) {
      return href;
    }
    if (href instanceof Object && !href.pathname) {
      href.pathname = router?.asPath;
    }
    const resolvedHref = resolveHref({} as Router, href);
    const isDefaultLang = language === siteConfig.defaultLang;
    return isDefaultLang ? resolvedHref : `/${language}${resolvedHref}`;
  };
  return { patchHrefLocale };
};

export default usePatchHrefLocale;
